import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

const MONO = `ui-monospace, SFMono-Regular, Menlo, Monaco, 'Cascadia Mono', 'Roboto Mono', monospace`;

export const StyledMcpHowTo = styled.section`
	max-width: 1240px;
	margin: 0 auto;
	padding: 60px 20px 40px;
	color: ${CSSVars.white};
	text-align: center;

	@media screen and (min-width: ${CSSVars.breakpointMD}) {
		padding: 80px 40px 40px;
	}

	.eyebrow {
		display: inline-block;
		font-family: ${MONO};
		font-size: ${CSSVars.fontSizeXS};
		font-weight: 500;
		letter-spacing: 2px;
		text-transform: uppercase;
		color: ${CSSVars.blue300};
		margin-bottom: 16px;
	}

	h3 {
		font-size: ${CSSVars.fontSize2XL};
		max-width: 760px;
		margin: 0 auto 16px;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			font-size: ${CSSVars.fontSize3XL};
		}

		.highlight {
			background: linear-gradient(270deg, #ff979c 0%, #4c4fff 100%);
			-webkit-background-clip: text;
			background-clip: text;
			-webkit-text-fill-color: transparent;
		}
	}

	p.intro {
		font-size: ${CSSVars.fontSizeMD};
		font-weight: 300;
		color: ${CSSVars.gray300};
		max-width: 580px;
		margin: 0 auto 56px;
	}

	.steps {
		display: grid;
		grid-gap: 24px;
		text-align: left;
		margin-bottom: 48px;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			grid-template-columns: repeat(3, 1fr);
		}
	}

	.step {
		border: 2px solid #1c1c20;
		border-radius: 10px;
		background: linear-gradient(
			-175deg,
			rgba(24, 24, 28, 1) 0%,
			rgba(0, 0, 0, 1) 100%
		);
		padding: 28px 26px;
	}

	.step-num {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 34px;
		height: 34px;
		border-radius: 10px;
		background: rgba(76, 79, 255, 0.12);
		border: 1px solid rgba(76, 79, 255, 0.35);
		color: ${CSSVars.blue300};
		font-family: ${MONO};
		font-weight: 600;
		font-size: ${CSSVars.fontSizeSM};
		margin-bottom: 18px;
	}

	.step h4 {
		font-size: ${CSSVars.fontSizeLG};
		font-weight: 600;
		margin-bottom: 8px;
	}

	.step p {
		font-size: ${CSSVars.fontSizeSM};
		font-weight: 300;
		line-height: 1.65;
		color: ${CSSVars.gray300};
	}

	/* connect block */
	.connect {
		max-width: 760px;
		margin: 0 auto;
		text-align: left;
		border: 2px solid #1c1c20;
		border-radius: 10px;
		background: linear-gradient(
			-175deg,
			rgba(24, 24, 28, 1) 0%,
			rgba(0, 0, 0, 1) 100%
		);
		padding: 26px 24px;
	}

	.connect .label {
		display: block;
		font-family: ${MONO};
		font-size: ${CSSVars.fontSizeXS};
		text-transform: uppercase;
		letter-spacing: 1px;
		color: ${CSSVars.gray500};
		margin: 18px 0 8px;

		&:first-child {
			margin-top: 0;
		}
	}

	.line {
		display: flex;
		align-items: stretch;
		background: #0c0d1c;
		border: 1px solid #23254a;
		border-radius: 9px;
		overflow: hidden;

		code {
			flex: 1;
			padding: 13px 14px;
			font-family: ${MONO};
			font-size: ${CSSVars.fontSizeSM};
			color: ${CSSVars.gray100};
			overflow-x: auto;
			white-space: nowrap;

			.prompt {
				color: ${CSSVars.pink300};
			}
		}

		button {
			flex-shrink: 0;
			border: none;
			border-left: 1px solid #23254a;
			background: transparent;
			color: ${CSSVars.blue300};
			font-family: ${MONO};
			font-size: ${CSSVars.fontSizeXS};
			font-weight: 600;
			letter-spacing: 0.5px;
			text-transform: uppercase;
			padding: 0 18px;
			cursor: pointer;
			transition: background 0.2s ease, color 0.2s ease;

			&:hover {
				background: rgba(76, 79, 255, 0.16);
				color: ${CSSVars.white};
			}
		}
	}

	.connect .note {
		font-size: ${CSSVars.fontSizeSM};
		font-weight: 300;
		line-height: 1.6;
		color: ${CSSVars.gray300};
		margin-top: 10px;

		strong {
			color: ${CSSVars.white};
			font-weight: 600;
		}

		code {
			font-family: ${MONO};
			font-size: ${CSSVars.fontSizeXS};
			color: ${CSSVars.blue300};
			background: #0c0d1c;
			border: 1px solid #23254a;
			border-radius: 6px;
			padding: 2px 7px;
		}
	}

	.docs-cta {
		margin-top: 40px;
		text-align: center;
	}
`;
